import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "charts gap-3 d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "chart"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "chart row"
}
const _hoisted_7 = { class: "fs-14 text-body-secondary fw-bold m-0 text-center" }
const _hoisted_8 = {
  key: 2,
  class: "chart"
}
const _hoisted_9 = { class: "fs-14 text-body-secondary fw-bold m-0 text-center" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 col-lg-6" }
const _hoisted_12 = { class: "mt-3 text-center" }
const _hoisted_13 = { class: "col-12 col-lg-6" }
const _hoisted_14 = { class: "mt-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_human_body_map_with_single_role = _resolveComponent("human-body-map-with-single-role")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.lineSeries()?.length != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t(`feature.roles.$type.${_ctx.role.patient}`)), 1 /* TEXT */),
          _createVNode(_component_apexchart, {
            height: "350",
            id: "lineCharts",
            options: _ctx.lineOptions(_ctx.role.patient),
            series: _ctx.lineSeries(_ctx.role.patient)
          }, null, 8 /* PROPS */, ["options", "series"]),
          _createElementVNode("div", {
            class: "small text-muted px-3",
            style: {"position":"relative","top":"-16px","font-size":"11px"},
            innerHTML: _ctx.lines_x_label
          }, null, 8 /* PROPS */, _hoisted_3),
          _createCommentVNode(" CAREGIVERS "),
          (_ctx.show_caregiver_series() ?? false)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t(`feature.roles.$type.${_ctx.role.caregiver}`)), 1 /* TEXT */),
                _createVNode(_component_apexchart, {
                  height: "350",
                  id: "lineCharts",
                  options: _ctx.lineOptions(_ctx.role.caregiver),
                  series: _ctx.lineSeries(_ctx.role.caregiver)
                }, null, 8 /* PROPS */, ["options", "series"]),
                _createElementVNode("div", {
                  class: "small text-muted px-3",
                  style: {"position":"relative","top":"-16px","font-size":"11px"},
                  innerHTML: _ctx.lines_x_label
                }, null, 8 /* PROPS */, _hoisted_5)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.barSeries)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plot_groups.bar, (step_id) => {
            return (_openBlock(), _createElementBlock("div", {
              key: step_id,
              class: "col-12 col-md-6 mb-3"
            }, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.getStep(step_id)?.title), 1 /* TEXT */),
              _createVNode(_component_apexchart, {
                height: "350",
                options: _ctx.barOptions(step_id, _ctx.getBarSeries(step_id)),
                series: _ctx.getBarSeries(step_id)
              }, null, 8 /* PROPS */, ["options", "series"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.plot_groups.body_map)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plot_groups.body_map, (step_id) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: step_id }, [
              _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.getStep(step_id)?.title), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.$t(`feature.roles.$type.${_ctx.role.patient}`)), 1 /* TEXT */),
                  _createVNode(_component_human_body_map_with_single_role, {
                    survey: _ctx.survey,
                    values: _ctx.body_map_groups[step_id],
                    role: _ctx.role.patient,
                    step_id: step_id
                  }, null, 8 /* PROPS */, ["survey", "values", "role", "step_id"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t(`feature.roles.$type.${_ctx.role.caregiver}`)), 1 /* TEXT */),
                  _createVNode(_component_human_body_map_with_single_role, {
                    survey: _ctx.survey,
                    values: _ctx.body_map_groups[step_id],
                    role: _ctx.role.caregiver,
                    step_id: step_id
                  }, null, 8 /* PROPS */, ["survey", "values", "role", "step_id"])
                ])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}